import { useState, useMemo } from "react";

export function useFilters(images, defaultSortKey = "typoloA") {
  const [filters, setFilters] = useState({});
  const [activeFilters, setActiveFilters] = useState([]);
  const [sortKey, setSortKey] = useState(defaultSortKey);

  // Construire hiérarchie à partir de la propriété "typoloA"
  const hierarchy = useMemo(() => {
    const h = {};

    images.forEach((img) => {
      const rawTag = img["typoloA"];
      //console.log("+", rawTag);
      if (!rawTag) return;

      const isPrimary = !rawTag.includes("_");
      if (!h[rawTag]) h[rawTag] = { primary: isPrimary, children: [] };

      if (!isPrimary) {
        const parent = rawTag.split("_")[0];
        if (!h[parent]) h[parent] = { primary: true, children: [] };
        if (!h[parent].children.includes(rawTag)) {
          h[parent].children.push(rawTag);
        }
      }
    });

    return h;
  }, [images]);
  //
  // console.log("•", hierarchy);
  // Map enfant → parent
  const childToParent = useMemo(() => {
    const map = {};
    Object.entries(hierarchy).forEach(([parent, def]) => {
      def.children?.forEach((child) => {
        map[child] = parent;
      });
    });
    return map;
  }, [hierarchy]);

  // Toggle filtre
  const toggleFilter = (tag) => {
    setFilters((prev) => ({
      ...prev,
      [tag]: !prev[tag],
    }));
    setActiveFilters((prev) =>
      prev.includes(tag) ? prev.filter((f) => f !== tag) : [...prev, tag]
    );
  };

  // Reset tous les filtres
  const resetFilters = () => {
    setFilters({});
    setActiveFilters([]);
  };

  // Filtrage tenant compte des parents
  const filteredImages = useMemo(() => {
    if (activeFilters.length === 0) return images;

    return images.filter((img) => {
      const tags = [img.typoloA, img.typoloB].filter(Boolean);

      return tags.some((rawTag) => {
        // Cas 1 : tag actif directement
        if (activeFilters.includes(rawTag)) return true;

        // Cas 2 : son parent est actif
        const parent = childToParent[rawTag];
        return parent && activeFilters.includes(parent);
      });
    });
  }, [images, activeFilters, childToParent]);

  const deactivateChildren = (parentKey) => {
    const children = hierarchy[parentKey]?.children || [];
    children.forEach((childKey) => {
      if (filters[childKey]) {
        toggleFilter(childKey); // désactive si actif
      }
    });
  };

  return {
    filters,
    activeFilters,
    toggleFilter,
    resetFilters,
    hierarchy,
    sortKey,
    setSortKey,
    filteredImages,
    deactivateChildren,
  };
}
